import { EditPicture } from './EditPicture';

export default EditPicture;
